import Backbone from 'backbone'
import _ from 'lodash'
import JSONStream from 'JSONStream'
import JsonStreamer from 'scoreboard/components/json-streamer'
import XhrStream from 'buffered-xhr-stream'
import deviceType from 'scoreboard/components/device-type'
import Xhr from 'scoreboard/components/xhr'
import constants from 'scoreboard/components/constants'

function MetricUpdatesRequester() {
	this.streamer = new JsonStreamer()
	this.streamer.on('data', this.trigger.bind(this))
	this.streamer.on('stream', this.trigger.bind(this, 'stream'))
	this.streamer.on('end', this.trigger.bind(this, 'end'))
}

_.extend(MetricUpdatesRequester.prototype, Backbone.Events, {

	getForPeriod: function(periodId, orgs) {
		// start streaming
		var url = 'api/scorecards/metric-updates?periods=true&calendarPeriodId=' + periodId
		if (orgs) {
			url += '&orgs=true'
		}
		let opts = { url: url, stream: 'metrics' }
		this.streamer.start(opts)
	},

	save: function(scores) {
		// Use Xhr so CSRF token is included
		const xhr = new Xhr({
			method: 'PUT',
			url: 'api/scorecards/metric-updates'
		})
		this.xhrStream = new XhrStream({
			xhr,
			contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
			data: JSON.stringify(scores)
		})
		var jsonStream = this.xhrStream.pipe(JSONStream.parse([true]))
		this.xhrStream.on('error', function(e) {
			jsonStream.emit('error', e)
		})
		return jsonStream
	},

	abort: function() {
		this.streamer.abort()
	}

})

export default MetricUpdatesRequester

MetricUpdatesRequester.__filename__ = 'home/metric-updates/metric-updates-requester.js'
